import React, { Fragment, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "../../UI/loader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel, makeStringStrictlyCapitalize, toBool } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { DayPicker } from "react-day-picker";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { popupOpenClose } from "../../../action/action";
import { scrollToTop } from "../../../JS/scrollToTop";

const SpaBooking3b = (props) => {
  const { t } = props;

  const [therapistPreferenceData, setTherapistPreferenceData] = useState([
    { key: "NO_PREFERENCE", value: "No Preference" },
    { key: "MALE", value: "Male" },
    { key: "FEMALE", value: "Female" },
  ]);
  const [therapistPreference, setTherapistPreference] =
    useState("NO_PREFERENCE");

  // below code is for rendering date:
  let dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;
  const [renderDateInput, setRenderDateInput] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [inputDateFormat, setInputDateFormat] = useState("");

  const getCheckoutDate =()=>{
        if(!JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))) return undefined;

        const guestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
        console.log( new Date(guestDetails.plannedCheckOutDate.replace('Z',"")) ,"getCheckoutDate")
        return guestDetails && guestDetails.plannedCheckOutDate ? new Date(guestDetails.plannedCheckOutDate.replace('Z',"")) : undefined
  } 

  const currentDate = new Date(props.serverTimeDate.replace("Z",""));
  const currentTime= currentDate.setHours(0,0,0,0);

  const checkoutDate = getCheckoutDate();

  const isDateDisabled=(date)=>{
    // console.log("currentDate",currentDate, date, props.serverTimeDate )

    return date.getTime() < currentTime || date>checkoutDate;
  }

  const handlePreCheckInSelectedDate = (selectedDate) => {
    if (!selectedDate) {
      setSelectedDate("");
      setInputDateFormat("");
    } else {
      // converting to local date string
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
      const day = String(selectedDate.getDate()).padStart(2, "0");

      const localDateString = `${year}-${month}-${day}`;
      setSelectedDate(localDateString);
      setInputDateFormat(
        dateFormatHandler(
          new Date(localDateString).toISOString(),
          props.dateFormat
        )
      );

      setRenderDateInput(false);
    }
  };

  // below code is for start time
  const selectItemsRef = React.useRef(null);
  const [eta, setETA] = React.useState("");
  const [etaTimeList, setETATimeList] = React.useState([]);
  const [customETASelect, setCustomETASelect] = React.useState(false);

  const formatEstimateCheckInTime = (time, timeFormat12hrs) => {
    if (!time) {
      return "";
    }

    const [hours, minutes] = time.split(":");

    if (timeFormat12hrs) {
      let period = "AM";
      let hour = parseInt(hours, 10);

      if (hour >= 12) {
        period = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      return `${hour}:${minutes} ${period}`;
    } else {
      return `${hours}:${minutes}`;
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 30) {
        const hourString = String(hours).padStart(2, "0");
        const minuteString = String(minutes).padStart(2, "0");
        const timeValue = `${hourString}:${minuteString}`;
        const formatedTimeValue = timeValue;
        options.push(formatedTimeValue);
      }
    }
    setETATimeList(options);
  };

  const handleETAScroll = () => {
    if (selectItemsRef.current) {
      const itemHeight = 45;
      const selectedItemIndex = etaTimeList.indexOf(eta);
      selectItemsRef.current.scrollTop = selectedItemIndex * itemHeight;
    }
  };

  React.useEffect(() => {
    if (customETASelect) handleETAScroll();
  }, [customETASelect]);

  // end



  const handleNext = () => {
    if (selectedDate == "") {
      props.popupOpenClose(true, t("spaBooking.select_preferred_date"));
      return;
    }

    let serviceDetailsPayload;

    if (eta) {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}T${eta}:00`,
        requestedType: therapistPreference,
      };
    } else {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}`,
        requestedType: therapistPreference,
      };
    }

    props.next(serviceDetailsPayload);
  };

  const editSelectedAddon=(addon)=>{
    
    //below is making deep copy (HACK)
    let selectedAddons= JSON.parse(JSON.stringify(props.selectedAddon));

    if(selectedAddons.some(addon_=>addon_.id==addon.id)){
      selectedAddons=  selectedAddons.filter(addon_=> addon_.id!=addon.id);
    }else{
      selectedAddons.push(addon)
    } 
    
    props.setSelectedAddon(selectedAddons);
    console.log("selectedAddon",selectedAddons)
  }
  useEffect(() => {
    generateTimeOptions();
    scrollToTop();
  }, []);



  useEffect(() => {
    console.log('props in updateresevationdtail', props)

    if (props.preferences.dateTime) {
      handlePreCheckInSelectedDate(new Date(props.preferences.dateTime))
      setTherapistPreference(props.preferences.gender);
    }
    else if (props.updateReservationDetails) {
      if (props.updateReservationDetails.lines[0].technician.gender && ['M', 'F'].includes(props.updateReservationDetails.lines[0].technician.gender)) {
        setTherapistPreference(props.updateReservationDetails.lines[0].technician.gender == "F" ? "FEMALE" : "MALE")
      }
      handlePreCheckInSelectedDate(new Date(props.updateReservationDetails.date))
    }



  }, [])

  return (
    <Fragment>
      <section class="widgets spa-listing spa-details treatment_additional_details_page">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">{makeStringStrictlyCapitalize(props.selectedService.name)}</div>
          <div class="widget-header-subtitle">
            {props.selectedService.service.description ||
              props.selectedService.service.extendedDescription}
          </div>
        </div>

        <div class="detail-body stay-body">
          <div class="stay-info">
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.duration")}</div>
              <div class="body">
                <p>{props.selectedService.service.duration} min</p>
              </div>
            </div>
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.base_price")}</div>
              <div class="body">
                <p>
                  {`${props.currencyCode} ${props.selectedService.service.price}`}<span class="spa-price-per-person 3b">{t("spaBooking.per_person")}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row treatment_additional_details" style={{ marginBottom: '4px' }}>
          <div class="col">
            <div class="detail-body stay-body">
              <form>

            { props.availableAddOns &&  Array.isArray(props.availableAddOns) && props.availableAddOns.length>0
                   && 
             
                  <div class="form-row spa-enhancements">
                  <p class="heading">{t("spaBooking.enhancements")}</p>
                  <p class="sub-heading">{t("spaBooking.enhancements_subheading")}</p>
                  <div class="form-options">
                    {
                      
                          props.availableAddOns.map((option) => (
                          <label class="spa-enhancement-option" key={option.id}>
                            <input
                              type="checkbox" 
                              checked={props.selectedAddon.some(addon=>addon.id==option.id)}
                              onChange={() => editSelectedAddon(option)}
                            />
                            <div class="name">
                              {option.name}
                              </div>
                              <div class="price">
                                {`${props.currencyCode} ${option.price}`}
                              </div>
                          </label>
                        ))
                  
                  }
                  </div>
                </div>
         

          }


    

                <div class="form-row">
                  <p class="heading">{t("spaBooking.therapist")}</p>
                  <div class="form-options">
                    {therapistPreferenceData.map((option) => (
                      <label key={option.key}>
                        <input
                          type="radio"
                          name="therapist"
                          value={option.key}
                          checked={therapistPreference === option.key}
                          onChange={() => setTherapistPreference(option.key)}
                        />
                        {option.value}
                      </label>
                    ))}
                  </div>
                </div>

                <div class="form-row">
                  <p class="heading">
                    {props.updateReservationDetails ? t("spaBooking.selected_date") : t("spaBooking.preferred_date")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                  <input
                    type="button"
                    value={
                      props.dateFormat && props.dateFormat != null
                        ? inputDateFormat ||
                        t("spaBooking.select_date_placeholder")
                        : selectedDate ||
                        t("spaBooking.select_date_placeholder")
                    }
                    onClick={() => setRenderDateInput(!renderDateInput)}
                  />
                </div>

                <div class="form-row spa-start-time">
                  <p class="heading">{t("spaBooking.preferred_time")}</p>

                  <div class={`custom-select`}>
                    <div
                      className="select-selected"
                      onClick={() => setCustomETASelect(!customETASelect)}
                    >
                      {eta
                        ? formatEstimateCheckInTime(
                          eta,
                          toBool(props.timeFormat)
                        )
                        : t("spaBooking.select_time_placeholder")}
                    </div>
                    <div className="select-items" ref={selectItemsRef}>
                      {customETASelect &&
                        etaTimeList.map((time, index) => {
                          return (
                            <div
                              onClick={(e) => {
                                setETA(time);
                                setCustomETASelect(!customETASelect);
                              }}
                              key={index}
                            >
                              {" "}
                              {formatEstimateCheckInTime(
                                time,
                                toBool(props.timeFormat)
                              )}{" "}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-controls">
            <button onClick={handleNext}>{t("spaBooking.next")}</button>
            <button onClick={props.goBack}>{t('spaBooking.back')}</button>
          </div>
        </div>

        {renderDateInput && (
          <div
            className="overlay"
            onClick={() => setRenderDateInput(!renderDateInput)}
          >
            <div
              onClick={(event) => {
                event.stopPropagation();
              }}
              class="overlay-date"
            >
              <style>{dateInputCss}</style>
              <DayPicker
                mode="single"
                selected={new Date(selectedDate)}
                onSelect={(selectedDate) => { console.log(selectedDate); handlePreCheckInSelectedDate(selectedDate) }
                }
                disabled={isDateDisabled}
              />
            </div>
          </div>
        )}
      </section>
    </Fragment>

  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    timeFormat:
      state.store.home.clientConfig.extraConfigParam &&
      state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    serverTimeDate: state.store.home.serverTimeDate.date,
    menuColor: state.store.home.MenuColor,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    currencyCode: state.store.home.clientConfig.currencyDetails
      ? state.store.home.clientConfig.currencyDetails.code
      : "",
  };
};

export default connect(mapStateToProps, {
  closeOrderPopUp,
  sendAnalytics,
  popupOpenClose,
})(withTranslation("translations")(SpaBooking3b));
